/// <reference path="utils.ts" />
import { Utils } from "./utils";
import { Point, Size, Rect } from '@pacem/pacem-foundation';
;
const NonePropertyConverter = { convert: (attr) => undefined };
const StringPropertyConverter = {
    convert: (attr) => attr, convertBack: (prop) => prop
};
const StringArrayPropertyConverter = {
    convert: (attr) => attr && attr.trim().split(/[ ,]+/), convertBack: (prop) => Utils.isArray(prop) && prop.join(' ') || ''
};
const NumberPropertyConverter = {
    convert: (attr) => parseFloat(attr), convertBack: (prop) => prop.toString()
};
const BooleanPropertyConverter = {
    convert: (attr) => !Utils.isNullOrEmpty(attr) && (attr !== '0') && (attr !== 'false'),
    convertBack: (prop) => (!!prop).toString()
};
const BooleanStrictPropertyConverter = {
    convert: (attr) => attr === 'true' || attr === '1',
    convertBack: (prop) => (!!prop).toString()
};
const DateTimePropertyConverter = {
    convert: (attr) => Utils.parseDate(attr),
    convertBack: (prop) => Utils.parseDate(prop).toISOString()
};
const DatePropertyConverter = DateTimePropertyConverter;
const JsonPropertyConverter = {
    convert: (attr) => Utils.Json.parse(attr),
    convertBack: (prop) => Utils.Json.stringify(prop)
};
const EvalPropertyConverter = {
    convert: (attr) => Function(`return ${attr};`).apply(null),
    convertBack: (prop) => undefined //JSON.stringify(prop)
};
const ElementPropertyConverter = {
    convert: (attr) => document.querySelector(attr),
    convertBack: (prop) => (prop instanceof Element && prop.id) ? ('#' + prop.id) : undefined,
    retryConversionWhenReady: true
};
const PointPropertyConverter = {
    convert: (attr) => Point.parse(attr),
    convertBack: (prop) => `${prop.x || 0} ${prop.y || 0}`
};
const SizePropertyConverter = {
    convert: (attr) => Size.parse(attr),
    convertBack: (prop) => `${prop.width || 0} ${prop.height || 0}`
};
const RectPropertyConverter = {
    convert: (attr) => Rect.parse(attr),
    convertBack: (prop) => `${prop.x || 0} ${prop.y || 0} ${prop.width || 0} ${prop.height || 0}`
};
export const PropertyConverters /*: { [name: string]: PropertyConverter }*/ = {
    None: NonePropertyConverter,
    String: StringPropertyConverter,
    StringArray: StringArrayPropertyConverter,
    Number: NumberPropertyConverter,
    Boolean: BooleanPropertyConverter,
    BooleanStrict: BooleanStrictPropertyConverter,
    Date: DatePropertyConverter,
    Datetime: DateTimePropertyConverter,
    Json: JsonPropertyConverter,
    Eval: EvalPropertyConverter,
    Element: ElementPropertyConverter,
    // geom
    Point: PointPropertyConverter,
    Rect: RectPropertyConverter,
    Size: SizePropertyConverter,
};
//}
